import React from "react";
export default function Currency(){
    return(
        <span className='rupee-symbol'>₹ </span>
    )
}